import { getClientConfig } from '../configuration/client-instance';
import type { IRequestOptions } from '../types';

export function buildUrl({ path, options }: { path: string; options?: IRequestOptions }): string {
  const config = getClientConfig();
  const base = `${config.baseUrl}${path}`;

  if (!options?.params) {
    return base;
  }

  const entries = Object.entries(options.params).filter(([, v]) => v !== undefined && v !== null);

  if (entries.length === 0) {
    return base;
  }

  const qs = entries
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join('&');
  return `${base}?${qs}`;
}
